/* eslint no-underscore-dangle: 0 */

/**
 * @private
 */
const TYPES = {
  _true: /true/i,
  _false: /false/i,
  _null: /null/i,
  _undefined: /undefined/i,
  _number: /^[0-9]+$/,
  _object: /^[{[].*[}\]]$/,
};

/**
 * @private
 * Parses the input value to the correct data type.
 *
 * @param  {any} value: value to test its type
 * @return {any}
 */
function parseType(value) {
  if (TYPES._true.test(value)) return true;
  if (TYPES._false.test(value)) return false;
  if (TYPES._null.test(value)) return null;
  if (TYPES._undefined.test(value)) return undefined;
  if (TYPES._number.test(value)) return +value;
  if (TYPES._object.test(value)) {
    try {
      value = JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
  return value;
}

/**
 * Try to parse the text to a primitive value.
 *
 * @param  {String} text: string to parse
 * @return {String}
 */
export default function getValue(text) {
  let value = parseType(decodeURIComponent(text));
  // prevents a string such as "00" be converted to number 0
  if (typeof value === 'number' && String(value).length !== text.length) {
    value = text;
  }
  return value;
}
